/** 大屏二级页共用：数字滚动、抽屉、简易灯箱、仅当前页 10s 刷新 */
import { isSameJson, stableStringify } from "@/utils/stableData";

export default {
  props: {
    commonFont: { type: Number, default: 14 },
    inspectMode: { type: Boolean, default: false }
  },
  data() {
    return {
      displayKpi: {},
      kpiRaf: null,
      kpiSig: "",
      lightbox: { open: false, list: [], index: 0 },
      refreshTimer: null,
      /** 组件存活且可见时才轮询 */
      _pageLive: false
    };
  },
  mounted() {
    this._pageLive = true;
  },
  activated() {
    this._pageLive = true;
  },
  deactivated() {
    this._pageLive = false;
    this.stopPageRefresh();
  },
  beforeDestroy() {
    this._pageLive = false;
    this.cancelKpiRoll();
    this.stopPageRefresh();
  },
  methods: {
    startPageRefresh(ms = 10000) {
      this.stopPageRefresh();
      this._pageLive = true;
      this.refreshTimer = setInterval(() => {
        if (!this._pageLive) return;
        if (
          typeof document !== "undefined" &&
          document.visibilityState === "hidden"
        ) {
          return;
        }
        if (typeof this.load === "function") this.load();
      }, ms);
    },
    stopPageRefresh() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },
    cancelKpiRoll() {
      if (this.kpiRaf) {
        cancelAnimationFrame(this.kpiRaf);
        this.kpiRaf = null;
      }
    },
    /**
     * KPI 完整对比：相同则不动；首次从 0 滚，之后从当前值滚到新值。
     */
    syncRollKpis(targets, forceFromZero = false) {
      const next = targets || {};
      const sig = stableStringify(next) || "";
      if (!forceFromZero && sig && sig === this.kpiSig) return;
      const fromZero = forceFromZero || !this.kpiSig;
      this.kpiSig = sig;
      this.rollKpis(next, fromZero);
    },
    /** 图表等切片：有变才 redraw */
    redrawIfChanged(sigProp, nextSlice, redrawFn) {
      if (isSameJson(nextSlice, this[sigProp])) return false;
      this[sigProp] = nextSlice;
      if (typeof redrawFn === "function") redrawFn();
      return true;
    },
    rollKpis(targets, fromZero = true) {
      this.cancelKpiRoll();
      const keys = Object.keys(targets || {});
      if (!keys.length) return;
      const start = {};
      keys.forEach(k => {
        start[k] = fromZero ? 0 : Number(this.displayKpi[k]) || 0;
      });
      const duration = 1000;
      const t0 = performance.now();
      const tick = now => {
        const p = Math.min(1, (now - t0) / duration);
        const e = 1 - Math.pow(1 - p, 3);
        const next = {};
        keys.forEach(k => {
          const a = start[k];
          const b = Number(targets[k]) || 0;
          next[k] = a + (b - a) * e;
        });
        this.displayKpi = next;
        if (p < 1) this.kpiRaf = requestAnimationFrame(tick);
        else this.kpiRaf = null;
      };
      this.kpiRaf = requestAnimationFrame(tick);
    },
    kpiInt(key) {
      const v = this.displayKpi[key];
      return v == null || Number.isNaN(v) ? "—" : Math.round(v);
    },
    openDrawer(payload) {
      this.$root.$emit("dash-drawer", payload);
    },
    openLightbox(list, index = 0) {
      const items = (list || []).filter(Boolean);
      if (!items.length) return;
      this.lightbox = {
        open: true,
        list: items,
        index: Math.max(0, Math.min(index, items.length - 1))
      };
    },
    closeLightbox() {
      this.lightbox = { open: false, list: [], index: 0 };
    },
    lightboxPrev() {
      const n = this.lightbox.list.length;
      if (!n) return;
      this.lightbox.index = (this.lightbox.index - 1 + n) % n;
    },
    lightboxNext() {
      const n = this.lightbox.list.length;
      if (!n) return;
      this.lightbox.index = (this.lightbox.index + 1) % n;
    },
    rateColor(rate, inspect) {
      const r = Number(rate) || 0;
      if (r >= 80) return "#36d7b7";
      if (r >= 70) return "#f5c542";
      return inspect ? "#36d7b7" : "#ff8a3d";
    },
    showLowRateWarn(rate) {
      return !this.inspectMode && Number(rate) < 70;
    }
  }
};
